import { FC, PropsWithChildren, useEffect } from 'react'

import { Theme, ThemeContext } from './context'
import { useStickyState } from '../state'
import { isEnabled } from '../toggles'

export const ThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches
  const [theme, setTheme] = useStickyState<Theme>(
    isEnabled('themeSwitcher') ? (prefersDarkMode ? 'dark' : 'light') : 'light',
    'theme'
  )

  useEffect(() => {
    document.body.classList.toggle('dark', theme === 'dark')
  }, [theme])

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>
}
